import React from 'react'
import Services from '../Components/Services'
import Oursolution from '../Components/Oursolution'
import Cards from '../Components/Cards'
import Yourcars from '../Components/Yourcars'
import Prices from '../Components/Prices'
// import Profilepage from '../Components/Profilepage'


function Servicespage() {
  return (
    <div>
     <Services/>
     <Oursolution/>
     <Yourcars/>
     <Prices/>
     {/* <Profilepage/> */}
    </div>
  )
}

export default Servicespage